export default "__VITE_ASSET__D5bskcRS__"